import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    // Use getSession (reads local storage, no network) so flaky connectivity
    // — common on the iOS simulator — doesn't bounce signed-in users back to
    // /auth and cause a reload loop. If there's no cached session at all,
    // then we know the user is signed out.
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: "/auth" });
    }
    return { user: data.session.user };
  },
  component: () => <Outlet />,
});
